export var SenderProfileAssigneeRecipient;
(function (SenderProfileAssigneeRecipient) {
    SenderProfileAssigneeRecipient["CC"] = "cc";
    SenderProfileAssigneeRecipient["BCC"] = "bcc";
})(SenderProfileAssigneeRecipient || (SenderProfileAssigneeRecipient = {}));
//# sourceMappingURL=senderProfile.js.map